export const ERROR_CODES = {
  PASSWORDLESS_USER_LOGIN_ATTEMPT_ERROR: 101,
  USER_ALREADY_EXISTS_ERROR: 102,
}
